<template>
  <v-navigation-drawer temporary
                       right
                       fixed
                       touchless
                       :width="drawerWidth"
                       v-model="showDrawer">
    <v-list>
      <v-list-item>
        <v-list-item-content class="mt-4" :class="{ 'px-12' : $vuetify.breakpoint.lgAndUp }">
          <v-list-item-title class="text-overline color-new-title-grey--text mb-3">{{ $t('changeLanguage') }}</v-list-item-title>
          <v-row>
            <v-col v-for="lang in languages"
                   :key="lang.locale"
                   v-if="lang.locale !== locale">
              <a class="text-uppercase font-weight-bold" @click="changeLocale(lang.locale)">
                {{ lang.fullText }}
              </a>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>

      <template v-if="$vuetify.breakpoint.mdAndDown">
        <v-divider class="my-3"></v-divider>
        <v-list-item v-for="item in menuItems"
                     v-if="item.visible"
                     :key="item.title"
                     :to="item.link"
                     @click="handleMenuItemClick(item)">


          <v-list-item-action>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-item-action>
          <v-list-item-content>{{item.title}}</v-list-item-content>
        </v-list-item>
        <v-divider class="my-3"></v-divider>
      </template>

      <v-list-item>
        <v-list-item-content :class="{ 'px-12' : $vuetify.breakpoint.lgAndUp }">
          <v-list-item-title class="text-overline color-new-title-grey--text mb-5">{{ $t('hd-text-1') }}</v-list-item-title>
          <shared-privacy-dialog />
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content :class="{ 'px-12' : $vuetify.breakpoint.lgAndUp }">
          <router-link to="/privacy" class="text-decoration-none">
            <a class="text-uppercase font-weight-bold">{{ $t('hd-text-2') }}</a>
          </router-link>
        </v-list-item-content>
      </v-list-item>

      <v-list-item class="mt-3">
        <v-list-item-content :class="{ 'px-12' : $vuetify.breakpoint.lgAndUp }">

          <v-btn tile color="color-new-link-blue" outlined dark @click="openFeedBackDialog" :block="$vuetify.breakpoint.mdAndDown">
            {{ $t('hd-text-3') }}
          </v-btn>
          <v-dialog v-model="generalFeedbackDialog"
                    :fullscreen="dialogSettings.fullscreen"
                    :scrollable="dialogSettings.scrollable"
                    :hide-overlay="dialogSettings.hideoverlay"
                    :transition="dialogSettings.transition"
                    :width="dialogSettings.width"
                    :max-width="dialogSettings.maxwidth">
            <v-card class="align-center">
              <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.mdAndDown">
                <v-toolbar-title>{{ $t('hd-text-3') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn light icon @click="generalFeedbackDialog = false">
                  <v-icon>fa-times</v-icon>
                </v-btn>
              </v-toolbar>
              <v-divider v-if="$vuetify.breakpoint.mdAndDown"></v-divider>
              <v-container class="pb-0" v-if="$vuetify.breakpoint.lgAndUp">
                <v-row justify="end">
                  <v-col class="shrink">
                    <v-btn color="color-grey" depressed right text small @click="generalFeedbackDialog = false">
                      <v-icon class="mr-3">fa-times</v-icon>
                      <span>{{ $t('close') }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
              <shared-general-feedback @close="generalFeedbackDialog = false"></shared-general-feedback>
            </v-card>
          </v-dialog>

        </v-list-item-content>
      </v-list-item>

      <template v-if="userIsAuthenticated">
        <v-divider class="mt-3 mb-6"></v-divider>
        <v-list-item @click="onLogout">
          <v-list-item-content class="text-uppercase font-weight-bold" :class="{ 'px-12' : $vuetify.breakpoint.lgAndUp }">
            <div>
              <v-icon color="red" class="mr-3">fas fa-power-off</v-icon>
              <span class="color-new-body-grey--text">{{ $t('logout') }}</span>
            </div>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-if="userIsAuthenticated">
        <v-dialog v-model="contactDialog"
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth">
      <shared-contact-dialog ref="contactDialog" @close="contactDialog = false"></shared-contact-dialog>
    </v-dialog>
      </template>
    </v-list>

  </v-navigation-drawer>

</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: function () {
      return {
        generalFeedbackDialog: false,
        contactDialog: false
      }
    },
    computed: {
      ...mapGetters({
        locale: 'locale',
        userIsAuthenticated: 'authenticated',
        languages: 'languages',
        hidePersonalInfo: 'hidePersonalInfo',
        hasJPVActiveDebtorNr: 'hasJPVActiveDebtorNr',
        hasOnlyOneDebt: 'hasOnlyOneDebt'
      }),
      showDrawer: {
        get: function () {
          return this.$store.getters.showDrawer
        },
        set: function (val) {
          this.$store.dispatch('setShowDrawer', val)
        }
      },
      drawerWidth() {
        return this.$vuetify.breakpoint.mdAndDown ? 250 : 360
      },
      menuItems() {
        let menuItems = [
          { icon: 'fas fa-sign-in-alt', title: this.$t('login'), link: '/', visible: true },
          { icon: 'fas fa-question-circle', title: this.$t('menu.help'), link: '/help', visible: true }
        ]
        if (this.userIsAuthenticated) {
          menuItems = [
            { icon: 'fas fa-home', title: this.$t('menu.frontPage'), link: '/front-page', visible: true },
            { icon: 'fas fa-credit-card', title: this.$t('menu.payments'), link: '/payments', visible: this.hasMultipleDebts },
            { icon: 'fas fa-comments', title: this.$t('menu.contact'), action: this.startContact, visible: true },
            { icon: 'fas fa-user', title: this.$t('menu.profile'), link: '/profile', visible: !this.hidePersonalInfo && this.hasJPVActiveDebtorNr},
            { icon: 'fas fa-question-circle', title: this.$t('menu.help'), link: '/help', visible: true }
          ]
        }
        return menuItems
      },
      hasMultipleDebts() {
        if (this.userIsAuthenticated && !this.hasOnlyOneDebt) {
          return true
        } else {
          return false
        }
      },
      dialogSettings() {
        return {
          fullscreen: this.$vuetify.breakpoint.smAndDown,
          scrollable: false,
          hideoverlay: this.$vuetify.breakpoint.smAndDown,
          transition: this.$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition',
          width: this.$vuetify.breakpoint.smAndDown ? 'auto' : '1024px',
          maxwidth: this.$vuetify.breakpoint.smAndDown ? 'none' : '90%'
        }
      }
    },
    methods: {
      handleMenuItemClick(item) {
        if (item.action) {
          item.action();
        } else if (this.$route.path !== item.link) {
          this.$router.push(item.link);
        }
        this.showDrawer = false;
      },
      onLogout() {
        this.$matomo && this.$matomo.trackEvent("Login", "Session End", "Session Logout")

        this.$store.dispatch('logout')
        window.localStorage.clear()
        this.$router.push('/')
      },
      changeLocale(locale) {
        this.$store.commit('setLocale', locale)
        this.showDrawer = false
        window.dispatchEvent(new Event('resize'))
      },
      openFeedBackDialog () {
        this.$matomo && this.$matomo.trackEvent("Action", "Give General Feedback", "Feedback Start")
        this.generalFeedbackDialog = true
      },
      startContact () {
        this.contactDialog = true;
        this.$nextTick(() => {
          this.$refs.contactDialog.setDefaultDebt();
        });
        this.$matomo && this.$matomo.trackEvent("Action", "Send Message", "Send Message Start")
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "hd-text-1": "Tietosuoja",
  "hd-text-2": "Tietoa evästeistä",
  "hd-text-3": "Anna palautetta"
  },
  "se": {
  "hd-text-1": "Dataskydd",
  "hd-text-2": "Information om webbkakor",
  "hd-text-3": "Ge respons"
  },
  "en": {
  "hd-text-1": "Privacy",
  "hd-text-2": "About cookies",
  "hd-text-3": "Give feedback"
  }
  }
</i18n>
